
const FileTypes = Object.freeze({
  GHX: 0,
  // NODI: 1,
  DXF: 2,
  PATH: 3,
  PLY: 4
});

const detectFileType = (path) => {
  let separated = path.split('.');
  switch (separated[separated.length - 1]) {
    case 'ghx':
    case 'GHX':
      return FileTypes.GHX;
    case 'dxf':
    case 'DXF':
      return FileTypes.DXF;
    case 'path':
    case 'PATH':
    case 'json':
    case 'JSON':
      return FileTypes.PATH;
    case 'ply':
    case 'PLY':
      return FileTypes.PLY;
  }
};

export default FileTypes;

export {
  detectFileType
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/FileTypes.js